import * as React from "react";
import { Button, CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const DialogForm = ({
  onAccept,
  onClose,
  open,
  title,
  message,
  children,
  isLoading,
  aceptLabel = "Aceptar",
  required = false,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
          {children}
        </DialogContent>
        <DialogActions>
          <Button onClick={onAccept}>
            {isLoading ? <CircularProgress size={24} /> : null} {aceptLabel}
          </Button>
          {required ? <Button onClick={onClose}>Cerrar</Button> : null}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default DialogForm;
